<div fxLayout="column" fxLayoutAlign="center center" class="neq-page">
  <ng-container>
    <h2>{{ titleMessage | translate }}</h2>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0.714rem">
      <span>{{ errorMessage | translate }}</span>
      <div fxLayout="row" fxLayoutGap="0.714rem">
        <a mat-button (click)="logout()">{{ 'label.common.logout' | translate }}</a>
      </div>
    </div>
  </ng-container>
</div>
